/**
 * 응시자에게 새 창으로 여는 외부 문서 링크.
 *
 * ASMT-PROCTOR-14 / -15 (TSK-11689 / TSK-11690): [도움말 보기]가 여는 해결 방안 문서는
 * 로그인하지 않은 외부 응시자도 열 수 있는 **공개 링크**여야 한다(기능 정의서 §7 확인 필요 사항).
 * 운영팀이 공개 링크를 확정하면 이 상수만 교체한다.
 */
export const ASSESSMENT_ENVIRONMENT_HELP_URL =
  "https://codepresso.notion.site/skillcertify-assessment-environment-help";
